var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Builder',{attrs:{"blocks":_vm.context.blocks,"context":{
    cityId: _vm.context.cityId,
    club: _vm.$route.params.club,
    date: _vm.$route.query.date,
    age: _vm.$route.params.age,
    zones: _vm.$route.query.zones,
    training: _vm.$route.query.training,
    trainer: _vm.$route.query.trainer,
    minigroup: _vm.$route.query.minigroup,
    sections: _vm.$route.query.sections,
    paid: _vm.$route.query.paid,
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }